import styled from "styled-components";

export const StyledSearchInput = styled.input.attrs(({ className = "" }) => ({
  className: `${className} input input-bordered border-quartenary rounded pl-2 pr-9 pt-3 h-[3rem] w-full text-vekin-green100 !text-sm font-semibold focus:outline-none hover:border-vekin-green40 focus:border-vekin cursor-pointer placeholder:font-normal bg-white disabled:bg-quartenary disabled:border-quartenary disabled:text-vekin/70 disabled:cursor-default`,
  autoComplete: "off",
}))``;

export const List = styled.ul.attrs(({ className }) => ({
  className: `shadow-lg flex flex-col gap-2 p-4 bg-white border max-h-[200px] w-full absolute mt-[3.1rem] z-[9999] rounded rounded-lg border-quarternary capitalize ${className} transition-all duration-300 overflow-y-auto overflow-x-hidden`,
}))``;

export const Option = styled.li.attrs(({ className }) => ({
  className: `${className}`,
}))``;

export const ListChild = styled.ul.attrs(({ className }) => ({
  className: `flex flex-col ${className} list-disc ml-9 gap-1 pb-2 pt-1`,
}))``;
